import React from "react";

const Notice = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        O.
        <span className="text-[#01A7D1] "> NOTICE</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <span className="text-lg font-medium">
          You agree that Yostel may provide you with notices, including those
          regarding changes to the Terms of Use, by email, regular mail, or
          postings on the <span className="text-lg font-medium">PLATFORM.</span>
        </span>
      </p>
    </div>
  );
};

export default Notice;
